import { nonEmptyString } from 'schemas/common';
import { z } from 'zod';

const baseSchema = z.object({
  alt: nonEmptyString,
  url: nonEmptyString,
});

export const urlSchema = z.object({
  apply: baseSchema.pick({ alt: true, url: true }),
  contact: baseSchema.pick({ alt: true, url: true }),
  endpoint: baseSchema.pick({ url: true }),
  logo: baseSchema.pick({ alt: true, url: true }),
  goToMainSite: baseSchema.pick({ alt: true, url: true }),
});
